import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../../ActionTypes';
import {
  postContactSupportService,
  postDisputeService
} from '../../../services/contact/contact.service';

function* postContactSupport(action: any): any {
  try {
    const contact = yield call(postContactSupportService, action.payload);
    if (contact.statusCode === 201) {
      yield put({
        type: type?.POST_CONTACT_SUPPORT_SUCCESS,
        contact: contact.data
      });
    } else {
      yield put({
        type: type?.POST_CONTACT_SUPPORT_FAILURE,
        message: 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type?.POST_CONTACT_SUPPORT_FAILURE,
      message: e.message
    });
  }
}
function* postDisputeSupport(action: any): any {
  try {
    const contact = yield call(postDisputeService, action.payload);
    if (contact.statusCode === 201) {
      yield put({
        type: type?.POST_CONTACT_SUPPORT_SUCCESS,
        contact: contact.data
      });
    } else {
      yield put({
        type: type?.POST_CONTACT_SUPPORT_FAILURE,
        message: contact?.data?.error[0] ?? 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type?.POST_CONTACT_SUPPORT_FAILURE,
      message: e.message
    });
  }
}

function* postContactSupportSaga() {
  yield takeEvery(type.POST_CONTACT_SUPPORT_REQUEST, postContactSupport);
  yield takeEvery(type.POST_DISPUTE_REQUEST, postDisputeSupport);
}

export default postContactSupportSaga;
